module.exports = __webpack_public_path__ + "static/gallery-1@2x-6b54eb34b7ebc74efaffa0db77044a63.jpg";